// Account actions for a Members row (approve, role, reset, block). Private libraries are owner-only, so no "View library".
export const Actions = ({ u, onPatch, onReset }) => (
  <div className="flex flex-wrap gap-2 justify-end">
    {u.role === "pending" && !u.blocked && (
      <>
        <button className="btn-primary !py-1 !px-3 text-xs" onClick={() => onPatch(u, { role: "family" })} data-testid={`approve-family-${u.user_id}`}>Approve as Family</button>
        <button className="btn-outline !py-1 !px-3 text-xs" onClick={() => onPatch(u, { role: "admin" })} data-testid={`approve-admin-${u.user_id}`}>Approve as Admin</button>
        <button className="btn-outline !py-1 !px-3 text-xs" onClick={() => onPatch(u, { blocked: true })} data-testid={`reject-${u.user_id}`}>Reject</button>
      </>
    )}
    {u.role !== "pending" && !u.blocked && (
      <>
        <button className="btn-outline !py-1 !px-3 text-xs" onClick={() => onPatch(u, { role: u.role === "admin" ? "family" : "admin" })} data-testid={`toggle-role-${u.user_id}`}>
          Make {u.role === "admin" ? "Family" : "Admin"}
        </button>
        <button className="btn-outline !py-1 !px-3 text-xs" onClick={() => onReset(u)} data-testid={`send-reset-${u.user_id}`}>Send reset email</button>
      </>
    )}
    {u.blocked
      ? <button className="btn-outline !py-1 !px-3 text-xs" onClick={() => onPatch(u, { blocked: false })} data-testid={`unblock-${u.user_id}`}>Unblock</button>
      : u.role !== "pending" && <button className="btn-outline !py-1 !px-3 text-xs" onClick={() => onPatch(u, { blocked: true })} data-testid={`block-${u.user_id}`}>Block</button>}
  </div>
);
